import _ from "lodash";
import React from "react";
import classes from "./PostAttachmentCard.scss";
import className from "classnames";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useTranslation } from "react-i18next";

import { MoveArrowsOutlined } from "@toddle-edu/ds-icons";
import { MediaCard } from "@toddle-edu/ds-web";

const PostAttachmentCard = React.memo(props => {
  const {
    id,
    isActive,
    mediaIndex,
    animateLayoutChanges,
    handleDelete,
    media,
  } = props;
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
  } = useSortable({
    id,
    data: { index: mediaIndex },
    animateLayoutChanges,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const { t } = useTranslation("common");
  const attachmentType = _.get(media, "type", "FILE");
  const name = _.isEqual(attachmentType, "NOTE")
    ? _.get(media, "title", "untitled")
    : _.get(media, "name", "untitled");
  const mimeType = _.get(media, "mimeType", "");
  const thumbUrl =
    attachmentType == "IMAGE"
      ? _.get(media, "url", "")
      : _.get(media, "thumbUrl", "");
  const url = _.get(media, "url", "");
  return (
    <div
      ref={setNodeRef}
      className={classes.container}
      style={style}
      {...attributes}
    >
      <MoveArrowsOutlined
        ref={setActivatorNodeRef}
        variant="subtle"
        className={className({
          [classes.cursorGrabbing]: isActive,
        })}
        {...listeners}
      />
      <div className={classes.mediacard}>
        <MediaCard
          cardType="medium"
          showSubtext={true}
          size={Math.ceil(_.get(media, "metadata.size", 0))}
          name={name}
          type={attachmentType}
          mimeType={mimeType}
          thumbUrl={thumbUrl}
          url={url}
        />
      </div>
      {/* Removing for DQC change keeping for future reference */}
      {/* <IconButton
        onClick={() => handleDelete({ id })}
        icon={<DeleteOutlined />}
        size="x-small"
        variant="plain"
      /> */}
    </div>
  );
});

export default PostAttachmentCard;
PostAttachmentCard.displayName = "PostAttachmentCard";
